import React from "react";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { clienteApi, servicosApi } from "../../services/Api";

import * as R from "ramda";

import {
  List,
  autocompleteHelpers,
  Autocomplete,
  loopback,
  Filter,
  ListApi,
  DatePicker,
  Select,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
} from "elentari";

import ClienteForm from "./ClienteForm";
import ClienteTreino from "./Treino/ClienteTreino";
import {
  InbodyList,
  InbodyForm,
  SecaList,
  SecaForm,
  ClienteServicosForm,
} from "../Servicos";

import { CardapiosList } from "../Nutricao/Cardapios";

const { loopbackFilters } = loopback;

function ClienteFilter(props) {
  return (
    <Filter
      formatFilters={{
        servicos: (values) => {
          return values.map((value) => value.id > 1);
        },
      }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item sm={4}>
          <Field fullWidth component={TextField} label="Nome" name="nome" />
        </Grid>
        <Grid item sm={4}>
          <Field fullWidth component={TextField} label="Alias" name="alias" />
        </Grid>
        <Grid item sm={4}>
          <Field
            fullWidth
            hideEmpty
            component={Select}
            options={[
              { label: "Todos", value: "" },
              { label: "Ativos", value: "true" },
              { label: "Inativos", value: "false" },
            ]}
            label="Situação"
            name="ativo"
          />
        </Grid>
        <Grid item sm={12}>
          <Field
            isMulti
            label="Serviço"
            loadOptions={loadServicos}
            component={Autocomplete}
            name="servicos"
          />
        </Grid>
        <Grid item sm={3}>
          <Field
            fullWidth
            component={DatePicker}
            label="Início Data Último Acesso"
            name="ultimoAcesso"
          />
        </Grid>
        <Grid item sm={3}>
          <Field
            fullWidth
            component={DatePicker}
            label="Fim Data Último Acesso"
            name="ultimoAcessoTo"
          />
        </Grid>
        <Grid item sm={3}>
          <Field
            fullWidth
            component={DatePicker}
            label="Início Data Bloqueio"
            name="dataBloqueio"
          />
        </Grid>
        <Grid item sm={3}>
          <Field
            fullWidth
            component={DatePicker}
            label="Fim Data Bloqueio"
            name="dataBloqueioTo"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

const loadServicos = async (inputValue) => {
  const response = await servicosApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

export function ClientesList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      id: {
        label: "Id",
      },
      nome: {
        label: "Nome",
      },
      alias: {
        label: "Alias",
      },
      ultimoAcesso: {
        label: "Último Acesso",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY HH:mm") : ""),
      },
      ultimaAvaliacao: {
        label: "Última Avaliação",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
      dataBloqueio: {
        label: "Data bloqueio",
        format: (date) =>
          date ? moment(date).add(3, "hours").format("DD/MM/YYYY") : "",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) {
      return undefined;
    }
    const promises = items.map(async (item) => {
      const response = await clienteApi.getLastClienteAval(item.id);
      if (response.ok && response.data) {
        item.ultimaAvaliacao = response.data.data;
        return item;
      }
      return item;
    });
    return Promise.all(promises);
  };

  const getStartOfDay = (date) => moment(date).startOf("day").toISOString();
  const getEndOfDay = (date) => moment(date).startOf("day").toISOString();

  const transformWhere = (where) => {
    const copy = { ...where };
    if (where.ultimoAcesso && where.ultimoAcessoTo) {
      copy.ultimoAcesso = {
        between: [
          getStartOfDay(copy.ultimoAcesso),
          getEndOfDay(copy.ultimoAcessoTo),
        ],
      };
    } else if (where.ultimoAcesso) {
      copy.ultimoAcesso = {
        between: [getStartOfDay(copy.ultimoAcesso), getEndOfDay(moment())],
      };
    } else if (where.ultimoAcessoTo) {
      copy.ultimoAcesso = {
        between: [
          getStartOfDay(new Date(2000, 0, 1)),
          getEndOfDay(copy.ultimoAcessoTo),
        ],
      };
    }
    if (where.dataBloqueio && where.dataBloqueioTo) {
      copy.dataBloqueio = {
        between: [
          moment(copy.dataBloqueio)
            .startOf("day")
            .subtract(3, "hours")
            .toISOString(),
          moment(copy.dataBloqueioTo)
            .endOf("day")
            .add(3, "hours")
            .toISOString(),
        ],
      };
    } else if (where.dataBloqueio) {
      copy.dataBloqueio = {
        between: [
          moment(copy.dataBloqueio)
            .startOf("day")
            .subtract(3, "hours")
            .toISOString(),
          moment().add(3, "hours").toISOString(),
        ],
      };
    } else if (where.dataBloqueioTo) {
      copy.dataBloqueio = {
        between: [
          getStartOfDay(new Date(2000, 0, 1)),
          moment(copy.dataBloqueioTo)
            .endOf("day")
            .add(3, "hours")
            .toISOString(),
        ],
      };
    }
    delete copy.dataBloqueioTo;
    delete copy.ultimoAcessoTo;
    return copy;
  };

  const getClienteCount = async (args) => {
    const filters = {
      ...args.filter,
      nome: args.filter.nome && loopbackFilters.regexp(args.filter.nome),
      alias: args.filter.alias && loopbackFilters.regexp(args.filter.alias),
    };
    const normalizedFilters = R.reject(R.equals(null))(filters);

    const argsForGetCount = { where: transformWhere(normalizedFilters) };

    const response = await clienteApi.getCount(argsForGetCount);
    return response.data.count;
  };

  return (
    <ListApi
      filtersConfig={{
        nome: loopbackFilters.regexp,
        alias: loopbackFilters.regexp,
      }}
      transformWhere={transformWhere}
      api={clienteApi}
      getPageDecorator={getPageDecorator}
    >
      {({ getPage }) => (
        <div>
          <ClienteFilter />
          <List
            {...props}
            withPaper
            onClickEdit={(item) => props.history.push(`/clientes/${item.id}`)}
            onClickNew={() => props.history.push("/clientes/new")}
            getPage={getPage}
            getCount={getClienteCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

export function ClienteTabs(props) {
  const { current, navigate, toEditChild, toNewChild } =
    useParentChildrenNavigation(props, {
      mainPath: "clientes",
      availableTabs: ["inbody", "seca", "servicos", "treinos", "cardapios"],
    });
  return (
    <CrudTabs
      {...props}
      mainPath="clientes"
      current={current}
      tabs={[
        { value: "", label: "Cliente" },
        { value: "inbody", label: "Inbody" },
        { value: "seca", label: "Seca" },
        { value: "cardapios", label: "Cardápios" },
        { value: "treinos", label: "Treinos" },
        { value: "servicos", label: "Serviços" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <ClienteForm {...props} />} />
        <CrudRoute
          name="inbody"
          render={(props) => (
            <InbodyList
              onClickNew={toNewChild}
              onClickEdit={toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute name="inbody" isForm component={InbodyForm} />
        <CrudRoute
          name="seca"
          render={(props) => (
            <SecaList
              {...props}
              onClickNew={toNewChild}
              onClickEdit={toEditChild}
            />
          )}
        />
        <CrudRoute name="seca" isForm component={SecaForm} />
        <CrudRoute
          name="servicos"
          render={(props) => <ClienteServicosForm {...props} />}
        />
        <CrudRoute name="treinos" component={ClienteTreino} />
        <CrudRoute
          name="cardapios"
          render={(props) => (
            <CardapiosList
              {...props}
              onClickNew={() =>
                props.history.push(
                  `/cardapios/new?clienteId=${props.match.params.id}`
                )
              }
            />
          )}
        />
      </div>
    </CrudTabs>
  );
}
